import { ref } from 'vue'

export const showErrorModal = ref(false)
export const modalMessage = ref('')
export const showLoginLink = ref(false) // ✅ NEW
